module.exports = __webpack_public_path__ + "assets/img/1_1654_big.0540261c.jpg";